import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import DoneIcon from "@mui/icons-material/Done";
import { useSelector } from "react-redux";
import { setIsLoading, setUserToken } from "../../../../../features/userSlice";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

interface CurrencyProps {
  open: boolean;
  handleClose: () => void;
  CurrencyName: any;
  setCurrencyName: any;
  CurrencyCode: any;
  setCurrencyCode: any;
  CurrencySymbol: any;
  setCurrencySymbol: any;
  selectedShareuid: any;
  setSelectedSharedUid: any;
  setMetaCurrencies: any;
  selectedRowData: any;
  setSelectedRowData: any;
  loading: any;
}

function EditCurrencyModal({
  open,
  handleClose,
  CurrencyName,
  setCurrencyName,
  CurrencyCode,
  setCurrencyCode,
  CurrencySymbol,
  setCurrencySymbol,
  selectedShareuid,
  selectedRowData,
}: CurrencyProps) {
  const token = useSelector(setUserToken);
  const oauthTokenHeader = token?.payload?.user?.userToken;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const UpdateNewCurrencyType = async () => {
    const data = {
      currency_name: CurrencyName,
      currency_code: CurrencyCode,
      currency_symbol: CurrencySymbol,
    };
    try {
      setLoading(true);
      setIsLoading(true);
      if (oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.updateMetaCurrencyType(
          oauthTokenHeader,
          data,
          selectedShareuid
        );
      } else {
        throw new Error("User doesn't have permissions to create Devie Type");
      }
      if (oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.getMetaCurrencyType(
          oauthTokenHeader,
          dispatch
        );
      }
    } catch (error) {
      console.error(error, "error");
    } finally {
      setLoading(false);
      setIsLoading(false);
      handleClose();
      await MetaEntitiesEndPointLogic.getMetaCurrencyType(
        oauthTokenHeader,
        dispatch
      );
    }
  };

  useEffect(() => {
    if (oauthTokenHeader) {
      setCurrencyName(selectedRowData?.currency_name);
      setCurrencyCode(selectedRowData?.currency_code);
      setCurrencySymbol(selectedRowData?.currency_symbol);
    }
  }, [
    oauthTokenHeader,
    selectedRowData,
    setCurrencyName,
    setCurrencyCode,
    setCurrencySymbol,
  ]);

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
        >
          <Paper sx={{ padding: "16px 24px 20px 24px" }}>
            <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
              Edit New Currency
            </DialogTitle>
            <Typography sx={{ mb: 1 }}>Details</Typography>
            <Grid container mt={0} columnSpacing={3}>
              <Grid item xs={6}>
                <TextField
                  value={CurrencyName}
                  onChange={(e: any) => setCurrencyName(e.target.value)}
                  id="outlined-multiline-flexible"
                  label="Currency Name *" // Set your label here
                  placeholder="Enter unique Currency Name" // Set your placeholder here
                  color="secondary"
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  value={CurrencyCode}
                  onChange={(e: any) => setCurrencyCode(e.target.value)}
                  id="outlined-multiline-flexible"
                  label="Currency Code *" // Set your label here
                  placeholder="Enter unique Currency Code" // Set your placeholder here
                  color="secondary"
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6} sx={{ mt: 2 }}>
                <TextField
                  value={CurrencySymbol}
                  onChange={(e: any) => setCurrencySymbol(e.target.value)}
                  id="outlined-multiline-flexible"
                  label="Currency Symbol *" // Set your label here
                  placeholder="Enter unique Currency Symbol" // Set your placeholder here
                  color="secondary"
                  size="small"
                  fullWidth
                />
              </Grid>
            </Grid>
            <Typography
              sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
            >
              All fields are mandatory.
            </Typography>

            <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
              <Button color="secondary" onClick={handleClose} sx={{ mr: 1 }}>
                CANCEL
              </Button>
              <Button
                variant="contained"
                color="secondary"
                disabled={!CurrencyName || !CurrencyCode || !CurrencySymbol}
                onClick={UpdateNewCurrencyType}
                data-tracker="235"
              >
                Save <DoneIcon sx={{ ml: 1 }} />
              </Button>
            </Stack>
          </Paper>
        </Dialog>
      )}
    </>
  );
}

export default EditCurrencyModal;
